import { useState } from "react";
import { Link } from "react-scroll";

export default function Navbar() {
  const [navBar, setNavBar] = useState(false);

  const changeBackground = () => {
    if (window.scrollY >= 30) {
      setNavBar(true);
    } else {
      setNavBar(false);
    }
  };
  //phone
  var $ham = document.querySelector('.hamburger-container') as HTMLElement,
    $pageBody = document.querySelector('.page-body') as HTMLElement;
  if ($ham) {
    $ham.onclick = function () {
      if ($ham?.classList.contains('open')) {
        $pageBody?.classList.remove('open');
        $ham.classList.remove('open');
      } else {
        $pageBody?.classList.add('open');
        $ham?.classList.add('open');
      }
    };

  }

  window.addEventListener("scroll", changeBackground);

  const isMobile = window.innerWidth <= 800;

  return (
    <>
      <section id='nav'>
        <header className={navBar ? "nav active" : "nav"}>
          <center className="">
            <nav className="nav__container__actions">
              <div>
                <ul className="navList mx-auto">
                  <li>
                    <Link
                      activeClass="active"
                      smooth="easeInOutBack"
                      spy
                      to="about"
                      offset={isMobile ? -100 : -130} // Add offset only on mobile
                      duration={500}
                    >
                      About
                    </Link>
                  </li>
                  <li>
                    <Link
                      activeClass="active"
                      smooth="easeInOutBack"
                      spy
                      to="tech"
                      offset={isMobile ? -100 : -130} // Add offset only on mobile
                      duration={500}
                    >
                      Technologies
                    </Link>
                  </li>
                  <li>
                    <Link
                      activeClass="active"
                      smooth="easeInOutBack"
                      spy
                      to="projects"
                      offset={isMobile ? -100 : -130} // Add offset only on mobile
                      duration={500}
                    >
                      Projects
                    </Link>
                  </li>
                  <li>
                    <Link
                      activeClass="active"
                      smooth="easeInOutBack"
                      spy
                      to="contact"
                      offset={isMobile ? -120 : -65} // Add offset only on mobile
                      duration={500}
                    >
                      Contact

                    </Link>
                  </li>
                  <li>
                    <a
                      href="https://drive.google.com/file/d/1BO-cCp0ieVF_ANoh9aY9MIPKwM7M35fK/view?usp=sharing"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Resume
                    </a>
                  </li>
                </ul>
              </div>
            </nav>
          </center>
        </header>
      </section>
      <section id='nav-mobile'>
        <nav className="nav-mobile">
          <div className="navbar">
            <div className="container-nav nav-container">
              <input className="checkbox" type="checkbox" name="" id="" />
              <div className="hamburger-lines">
                <span className="line line1"></span>
                <span className="line line2"></span>
                <span className="line line3"></span>
              </div>
              <div className="menu-items">
                <li>
                  <Link
                    activeClass="active"
                    smooth="easeInOutBack"
                    spy
                    to="about"
                    offset={-15} // Add offset only on mobile
                    duration={500}
                  >
                    About
                  </Link>
                </li>
                <li>
                  <Link
                    activeClass="active"
                    smooth="easeInOutBack"
                    spy
                    to="tech"
                    offset={-10} // Add offset only on mobile
                    duration={500}
                  >
                    Tech
                  </Link>
                </li>
                <li>
                  <Link
                    activeClass="active"
                    smooth="easeInOutBack"
                    spy
                    to="projects"
                    offset={-10} // Add offset only on mobile
                    duration={500}
                  >
                    Projects
                  </Link>
                </li>
                <li>
                  <Link
                    activeClass="active"
                    smooth="easeInOutBack"
                    spy
                    to="contact"
                    offset={0} // Add offset only on mobile
                    duration={500}
                  >
                    Contact Me

                  </Link>
                </li>
                <li>
                  <a
                    href="https://drive.google.com/file/d/1BO-cCp0ieVF_ANoh9aY9MIPKwM7M35fK/view?usp=sharing"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Resume
                  </a>
                </li>
              </div>
            </div>
          </div>
        </nav>
      </section>
    </>
  );
}
